export default "__VITE_ASSET__h7vzCga___"